// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__iXBQE","selected":"Chip_selected__3ymp-"};